import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchSubDashBoardAssignUserList = createAsyncThunk("fetchSubDashBoardAssignUserList", async ({ id }) => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};
	const response = await axiosHttp.get(`analytics/subdashboard/employee/list?subDashBoardId=${id}`, config);
	return response.data.data;
});

const SubDashboardAssignedUserListSlice = createSlice({
	name: "SubDashboardAssignedUserListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},
	extraReducers: (builder) => {
		builder.addCase(fetchSubDashBoardAssignUserList.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchSubDashBoardAssignUserList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchSubDashBoardAssignUserList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default SubDashboardAssignedUserListSlice.reducer;
